import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RoleService } from '../../services/role.service';
import { Role } from '../../model/role.model';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-role-list',
  standalone: true,
  imports: [CommonModule, ButtonModule, FormsModule],
  templateUrl: './role-list.component.html',
  styleUrls: ['./role-list.component.css']
})
export class RoleListComponent implements OnInit {
  roles: Role[] = [];        // filtered roles shown in UI
  allRoles: Role[] = [];     // full unfiltered list from backend
  totalRoles: number = 0;
  errorMessage: string | null = null;
  searchTerm: string = '';   // for search box binding

  constructor(private roleService: RoleService, private router: Router) {}

  ngOnInit(): void {
    this.loadRoles();
  }

  loadRoles(): void {
    this.roleService.getAllRoles().subscribe({
      next: (data) => {
        console.log('Received roles:', data);
        // filter out Fixed Biometric from original data
        this.allRoles = data.filter(role =>
          role.roleName?.toLowerCase() !== 'fixed biometric' &&
          role.roleCode?.toLowerCase() !== 'fixed biometric'
        );
        // at first show all
        this.roles = [...this.allRoles];
        this.totalRoles = this.roles.length;
        this.errorMessage = null;
      },
      error: (err) => {
        console.error('Error loading roles:', err);
        this.roles = [];
        this.allRoles = [];
        this.totalRoles = 0;
        this.errorMessage = err.message || 'Failed to load roles. Please try again.';
      }
    });
  }

  // 🔹 Search function
searchRoles(): void {
  const term = this.searchTerm.trim().toLowerCase();

  if (!term) {
    this.roles = [...this.allRoles];
  } else {
    const startsWithMatches = this.allRoles.filter(role =>
      role.roleName?.toLowerCase().startsWith(term) ||
      role.roleCode?.toLowerCase().startsWith(term)
    );

    const containsMatches = this.allRoles.filter(role =>
      !(
        role.roleName?.toLowerCase().startsWith(term) ||
        role.roleCode?.toLowerCase().startsWith(term)
      ) &&
      (
        role.roleName?.toLowerCase().includes(term) ||
        role.roleCode?.toLowerCase().includes(term)
      )
    );

    // Optional: alphabetically sort within each group
    startsWithMatches.sort((a, b) => a.roleName.localeCompare(b.roleName));
    containsMatches.sort((a, b) => a.roleName.localeCompare(b.roleName));

    // Combine results: prefix matches first, then substring matches
    this.roles = [...startsWithMatches, ...containsMatches];
  }

  this.totalRoles = this.roles.length;
}


  getMenuMapping(role: Role): string {
    return role.menuPermissions?.map(perm => perm.menu?.menuName).filter(name => name).join(', ') || 'None';
  }

  formatDate(timestamp: number | undefined): string {
    if (!timestamp) return 'N/A';
    const date = new Date(timestamp);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  }

  viewRole(id: number): void {
    this.router.navigate(['/roles', id], { queryParams: { mode: 'view' } });
  }

  deleteRole(id: number): void {
    if (confirm('Are you sure?')) {
      this.roleService.deleteRole(id).subscribe({
        next: () => this.loadRoles(),
        error: (err) => {
          console.error('Error deleting role:', err);
          this.errorMessage = 'Failed to delete role. Please try again.';
        }
      });
    }
  }
}
